import { Header, Lore, About, Roadmap, Team, Faq } from '../containers';
import { MostSimpsContent, Footer, MobileNavbar } from '../components';
import AboutPage from './About';

const WantedSimps = () => {
    return(
    <div className="w-screen text-center select-none">
        <MostSimpsContent />
    </div>
    )};
  
  export default WantedSimps;